import { Button, DatePicker, Divider, Flex } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { TravelPeopleMonthLine } from "./TravelPeopMonthLine";

export const dateFormat = "YYYY-MM-DD";
export const dateFormatByMonth = "YYYY-MM";

export function MonthGraph() {
	const [selectedDateByMonth, setSelectedDateByMonth] = useState({
		startDate: dayjs().subtract(6, "month").format(dateFormatByMonth),
		endDate: dayjs().format(dateFormatByMonth),
	});

	const handleMonthChange = (data) => {
		setSelectedDateByMonth({
			startDate: dayjs()
				.subtract(data, "month")
				.format(dateFormatByMonth),
			endDate: dayjs().format(dateFormatByMonth),
		});
	};

	const mappingData = {
		month: [
			{
				data: 1,
				label: "过去1个月",
			},
			{
				data: 2,
				label: "过去2个月",
			},
			{
				data: 6,
				label: "过去6个月",
			},
			{
				data: 12,
				label: "过去12个月",
			},
		],
	};

	return (
		<div style={{ minWidth: "800px" }}>
			<Flex gap="large" justify="center" align="center">
				<Flex gap="large" justify="flex-start" align="center">
					<DatePicker.RangePicker
						key="month"
						allowEmpty={[false, false]}
						value={[
							dayjs(
								selectedDateByMonth.startDate,
								dateFormatByMonth
							),
							dayjs(
								selectedDateByMonth.endDate,
								dateFormatByMonth
							),
						]}
						format={dateFormatByMonth}
						onChange={(date, dateString) => {
							setSelectedDateByMonth({
								startDate: dateString[0],
								endDate: dateString[1],
							});
						}}
						allowClear={false}
						picker="month"
					/>

					<Divider type="vertical" style={{ height: "40px" }} />

					<Flex
						gap="10px"
						justify="flex-start"
						align="center"
						wrap="wrap"
						style={{ width: "300px", height: "92px" }}
					>
						{mappingData.month.map((m) => (
							<Button
								onClick={() => handleMonthChange(m.data)}
								size="small"
							>
								{m.label}
							</Button>
						))}
					</Flex>
				</Flex>
			</Flex>
			<TravelPeopleMonthLine selectedDateByMonth={selectedDateByMonth} />
		</div>
	);
}
